<script>
import DatePicker from "vue2-datepicker";
import Drawer from "@/components/drawer";
import moment from "moment";
import Multiselect from "vue-multiselect";

// Custom Components
import BookingDetails from "@/components/booking-details.vue";
import BookingService from "@/helpers/APIService/booking.service";
import RoomService from "@/helpers/APIService/room.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import Pagination from "@/components/Pagination.vue";
import HotelService from "@/helpers/APIService/hotel.service";

export default {
  title: "filter",
  data() {
    return {
      filter: {
        guests: "",
        page_number: 50,
        reference_no: "",
        reference_no_type: "Reference No",
        last_name: "",
        first_name: "",
        room_number: "",
        room_type: "",
        booking_status: [],
        payment_type: "",
        arrival_start_date: "",
        arrival_end_date: "",
        departure_start_date: "",
        departure_end_date: "",
        payment_due_date: "",
        rate_code: [],
        booking_source: [],
        mobile_key_support: "",
        email_address: "",
        mobile_number: "",
      },
      isDataLoading: false,
      totalPages: null,
      resultsNotFound: false,
      table: {
        tableData: [],
      },
      isShowFilter: true,
      guestOptions: [{ text: "Any", value: "" }],
      pageNumberOptios: [],
      confirCodeTypeOptions: [],
      roomTypeArr: [],
      roomRatePlansArr: [],
      booking_source: [],
      bookingStatusOptions: [],
      viewBookingDetails: false,
      selectedBooking: null,
      currentQuerryString: null,
      // conditions: {
      //   guests: "and_total_guest",
      //   reference_no: "and_reference_no__iexact",
      //   // reference_no_type: "and_status",
      //   last_name: "and_primary_guest__last_name__iexact",
      //   first_name: "and_primary_guest__first_name__iexact",
      //   room_number: "and_allotted_room__room_number",
      //   // room_type: "and_status",
      //   booking_status: "and_status",
      //   // payment_type: "and_status",
      //   arrival_start_date: "and_check_in_date",
      //   // arrival_end_date: "and_status",
      //   departure_start_date: "and_check_out_date",
      //   // departure_end_date: "and_status",
      //   // payment_due_date: "and_status",
      //   // rate_code: "and_total_guest",
      // },
    };
  },
  components: {
    Drawer,
    DatePicker,
    BookingDetails,
    Pagination,
    Multiselect,
  },
  computed: {
    ...authComputed,
    bookingDetailsProps() {
      return {
        booking: this.selectedBooking,
      };
    },
  },
  mounted() {
    this.setOptions(`?size=${this.filter.page_number}`);
    this.getRoomDetailsData();
    this.getRoomRatePlans();
    this.getBookingSource();
  },
  methods: {
    // Method is used to show and hide filter collapse
    showHideFilter() {
      this.isShowFilter = !this.isShowFilter;
    },
    // Method is used to set options values
    setOptions() {
      for (let index = 1; index <= 10; index++) {
        this.guestOptions.push({ text: index, value: index });
      }
      this.pageNumberOptios = [
        { text: "50", value: 50 },
        { text: "100", value: 100 },
        { text: "200", value: 200 },
        { text: "300", value: 300 },
        { text: "All", value: "" },
      ];
      this.confirCodeTypeOptions = [
        "Reference No",
        "OTA Reference No",
        "PMS Reference No",
      ];
      this.bookingStatusOptions = [
        { value: "new_booking", text: "New" },
        { value: "pre_checkin", text: "Pre CheckIn" },
        { value: "pre_checked_done", text: "Pre CheckedIn Done" },
        { value: "due_in_hold", text: "Due In-Hold" },
        { value: "due_in", text: "Confirmed" },
        { value: "checked_in", text: "Due In" },
        { value: "due_out", text: "Checked In" },
        { value: "checked_out", text: "Checked Out" },
        { value: "cancelled", text: "Cancelled" },
        { value: "no_show", text: "No Show" },
      ];
    },
    async getRoomDetailsData() {
      try {
        let response = await RoomService.getRoomTypeList();
        if (response) {
          response.forEach((element) => {
            this.roomTypeArr.push({
              ...element,
              text: element.name,
              value: element.id,
            });
          });
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is sued to get booking list
    async getBookingList(query) {
      this.isDataLoading = true;
      await BookingService.getBookingList(query)
        .then((response) => {
          this.table.tableData = response.results;
          this.table.totalPages = response.total_pages;
          this.table.currentPage = response.page_number;
          this.isDataLoading = false;
          if (response.results.length == 0) {
            this.resultsNotFound = true;
          } else {
            this.resultsNotFound = false;
          }
        })
        .catch((error) => {
          errorHandler(error);
          this.isDataLoading = false;
        });
    },
    async getRoomRatePlans() {
      try {
        let response = await RoomService.getRatePlanList();
        if (response) {
          response.forEach((element) => {
            this.roomRatePlansArr.push({
              ...element,
              text: element.name,
              value: element.id,
            });
          });
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    async getBookingSource() {
      try {
        let response = await HotelService.getBookingSourceList();
        if (response) {
          response.forEach((element) => {
            this.booking_source.push({
              ...element,
              text: element.name,
              value: element.id,
            });
          });
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is reload query based booking
    reloadQuery() {
      this.getBookingList(this.currentQuerryString);
    },
    // Method is used to handle open booking details
    async openBookingDetails(data = null) {
      if (data != null) {
        this.selectedBooking = data;
      }
      this.viewBookingDetails = !this.viewBookingDetails;
    },
    // EXTRA METHODS

    // Method is used to handle pagination
    onPageChange(page) {
      if (page != this.table.currentPage) {
        this.getBookingList(`${this.currentQuerryString}&page=${page}`);
      }
    },
    //Method kiosk policy
    copyCode(code) {
      Middleware.copyCode(code);
    },
    // Method is used to avatar generate
    avatarGenerator(name) {
      return Middleware.avatarGenerator(name);
    },
    // Method is used to get ago from updated date
    getAgo(date) {
      return moment(date).fromNow(true);
    },
    doSearch(data) {
      let queryString =
        this.filter.page_number != "" ? `?size=${this.filter.page_number}` : "";
      for (const property in data) {
        if (data[property] != "" && data[property] != null) {
          // for (const condition in this.conditions) {
          //   if (condition == property) {
          //     queryString += `&${this.conditions[condition]}=${data[property]}`;
          //   }
          // }
          if (property == "guests") {
            queryString += `&and_total_guest=${data[property]}`;
          }
          if (property == "reference_no") {
            queryString += `&or_reference_no__iexact=${data[property]}&or_booking_source_reference_no__iexact=${data[property]}&or_ota_reference_no__iexact=${data[property]}`;
          }
          if (property == "last_name") {
            queryString += `&and_primary_guest__last_name__iexact=${data[property]}`;
          }
          if (property == "first_name") {
            queryString += `&and_primary_guest__first_name__iexact=${data[property]}`;
          }
          if (property == "room_number") {
            queryString += `&and_allotted_room__room_number=${data[property]}`;
          }
          if (property == "room_type") {
            for (let index = 0; index < this.filter.room_type.length; index++) {
              const element = this.filter.room_type[index].value;
              if (this.filter.room_type[index].value != "") {
                queryString += `&room_type__id=${element}`;
              }
            }
          }
          if (property == "booking_status") {
            for (
              let index = 0;
              index < this.filter.booking_status.length;
              index++
            ) {
              const element = this.filter.booking_status[index].value;
              if (this.filter.booking_status[index].value != "") {
                queryString += `&status=${element}`;
              }
            }
          }
          if (property == "arrival_start_date") {
            queryString += `&and_check_in_date__gte=${data[property]}`;
          }
          if (property == "arrival_end_date") {
            queryString += `&and_check_in_date__lte=${data[property]}`;
          }
          if (property == "departure_start_date") {
            queryString += `&and_check_out_date__gte=${data[property]}`;
          }
          if (property == "departure_end_date") {
            queryString += `&and_check_out_date__lte=${data[property]}`;
          }
          if (property == "rate_code") {
            for (let index = 0; index < this.filter.rate_code.length; index++) {
              const element = this.filter.rate_code[index].value;
              queryString += `&rate_plan=${element}`;
            }
          }
          if (property == "booking_source") {
            for (
              let index = 0;
              index < this.filter.booking_source.length;
              index++
            ) {
              const element = this.filter.booking_source[index].value;
              queryString += `&booking_source__id=${element}`;
            }
          }
          if (property == "email_address") {
            queryString += `&or_primary_guest__email__iexact=${data[property]}`;
          }
          if (property == "mobile_number") {
            queryString += `&or_primary_guest__mobile__iexact=${data[property]}`;
          }
        }
      }
      this.currentQuerryString = queryString;
      this.getBookingList(queryString);
    },
    notBeforeArrivalStart(date) {
      return date < new Date(this.filter.arrival_start_date);
    },
    notBeforeDepartureStart(date) {
      return date < new Date(this.filter.departure_start_date);
    },
    clearFields() {
      for (const key in this.filter) {
        if (Object.hasOwnProperty.call(this.filter, key)) {
          this.filter[key] = "";
        }
      }
      this.filter.page_number = 50;
      this.filter.reference_no_type = "Reference No";
    },
  },
};
</script>

<template>
  <div>
    <div role="tablist">
      <b-card no-body>
        <b-card-header header-tag="header" role="tab" v-b-toggle.accordion-1>
          <h6 class="py-2 m-0" @click="showHideFilter()">
            <a class="text-dark" href="javascript: void(0);">
              <i
                class="me-1"
                :class="
                  !isShowFilter ? 'fas fa-chevron-up' : 'fas fa-chevron-down'
                "
              >
              </i>
              Booking Search
            </a>
          </h6>
        </b-card-header>
        <b-collapse
          id="accordion-1"
          visible
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <b-card-text>
              <div class="container-fluid">
                <div class="row flex-wrap">
                  <div class="col-xl-2 col-md-3 col-sm-6">
                    <div class="mb-3">
                      <label for="confrimation_code">Confirmation Code</label>
                      <b-form-input
                        type="text"
                        id="confrimation_code"
                        placeholder="Confirmation Code"
                        v-model.trim="filter.reference_no"
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-xl-2 col-md-3 col-sm-6">
                    <div class="mb-3">
                      <label for="last_name">Last Name</label>
                      <b-form-input
                        type="text"
                        id="last_name"
                        placeholder="Last Name"
                        v-model.trim="filter.last_name"
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-xl-2 col-md-3 col-sm-6">
                    <div class="mb-3">
                      <label for="first_name">First Name</label>
                      <b-form-input
                        type="text"
                        id="first_name"
                        placeholder="First Name"
                        v-model.trim="filter.first_name"
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-xl-2 col-md-3 col-sm-6">
                    <div class="mb-3">
                      <label for="email_address">By Email</label>
                      <b-form-input
                        type="text"
                        id="email_address"
                        placeholder="Email Address"
                        v-model.trim="filter.email_address"
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-xl-2 col-md-3 col-sm-6">
                    <div class="mb-3">
                      <label for="mobile_number">By Mobile Number</label>
                      <b-form-input
                        type="text"
                        id="mobile_number"
                        placeholder="Mobile Number"
                        v-model.trim="filter.mobile_number"
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-xl-2 col-md-3 col-sm-6">
                    <div class="mb-3">
                      <label for="guests">Number of Guests</label>
                      <b-form-select
                        type="text"
                        class="form-select"
                        id="guests"
                        placeholder="Guests"
                        v-model.trim="filter.guests"
                        :options="guestOptions"
                      ></b-form-select>
                    </div>
                  </div>
                  <div class="col-xl-2 col-md-3 col-sm-6">
                    <div class="mb-3">
                      <label for="booking_status">Booking Status</label>
                      <multiselect
                        v-model.trim="filter.booking_status"
                        track-by="value"
                        label="text"
                        placeholder="Booking Status"
                        :options="bookingStatusOptions"
                        :multiple="true"
                        :show-labels="false"
                      >
                      </multiselect>
                    </div>
                  </div>
                  <div class="col-xl-2 col-md-3 col-sm-6">
                    <div class="mb-3">
                      <label for="room_number">Room</label>
                      <b-form-input
                        type="text"
                        id="room_number"
                        placeholder="Room Number"
                        v-model.trim="filter.room_number"
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-xl-2 col-md-3 col-sm-6">
                    <div class="mb-3">
                      <label for="room_type">Room Type</label>
                      <multiselect
                        v-model.trim="filter.room_type"
                        track-by="value"
                        label="text"
                        placeholder="Room type"
                        :options="roomTypeArr"
                        :multiple="true"
                        :show-labels="false"
                      >
                      </multiselect>
                    </div>
                  </div>
                  <div class="col-xl-2 col-md-3 col-sm-6">
                    <div class="mb-3">
                      <label for="">Arrival Start</label>
                      <date-picker
                        lang="en"
                        placeholder="Select Arrival Start"
                        type="date"
                        value-type="format"
                        v-model.trim="filter.arrival_start_date"
                      ></date-picker>
                    </div>
                  </div>
                  <div class="col-xl-2 col-md-3 col-sm-6">
                    <div class="mb-3">
                      <label for="">Arrival End</label>
                      <date-picker
                        lang="en"
                        placeholder="Select Arrival End"
                        type="date"
                        value-type="format"
                        :disabled-date="notBeforeArrivalStart"
                        v-model.trim="filter.arrival_end_date"
                      ></date-picker>
                    </div>
                  </div>
                  <div class="col-xl-2 col-md-3 col-sm-6">
                    <div class="mb-3">
                      <label for="">Departure Start</label>
                      <date-picker
                        lang="en"
                        placeholder="Select Departure Start"
                        type="date"
                        value-type="format"
                        v-model.trim="filter.departure_start_date"
                      ></date-picker>
                    </div>
                  </div>
                  <div class="col-xl-2 col-md-3 col-sm-6">
                    <div class="mb-3">
                      <label for="">Departure End</label>
                      <date-picker
                        lang="en"
                        placeholder="Select Departure End"
                        type="date"
                        value-type="format"
                        :disabled-date="notBeforeDepartureStart"
                        v-model.trim="filter.departure_end_date"
                      ></date-picker>
                    </div>
                  </div>
                  <div class="col-xl-2 col-md-3 col-sm-6">
                    <div class="mb-3">
                      <label for="rete_plan_type">Rate Code</label>
                      <multiselect
                        v-model.trim="filter.rate_code"
                        track-by="name"
                        label="name"
                        placeholder="Rate Plans"
                        :options="roomRatePlansArr"
                        :multiple="true"
                        :show-labels="false"
                      >
                      </multiselect>
                    </div>
                  </div>
                  <div class="col-xl-2 col-md-3 col-sm-6">
                    <div class="mb-3">
                      <label for="page_number">Booking Source</label>
                      <multiselect
                        v-model.trim="filter.booking_source"
                        track-by="name"
                        label="name"
                        placeholder="Booking Sources"
                        :options="booking_source"
                        :multiple="true"
                        :show-labels="false"
                      >
                      </multiselect>
                    </div>
                  </div>
                  <div class="col-xl-2 col-md-3 col-sm-6">
                    <div class="mb-3">
                      <label for="page_number">Results per page</label>
                      <b-form-select
                        type="text"
                        class="form-select"
                        id="page_number"
                        v-model.trim="filter.page_number"
                        :options="pageNumberOptios"
                      ></b-form-select>
                    </div>
                  </div>
                  <div class="col-xl-12">
                    <div class="float-end">
                      <b-button
                        :disabled="isDataLoading"
                        variant="primary"
                        class="me-2"
                        @click="doSearch(filter)"
                      >
                        <i
                          v-if="isDataLoading"
                          class="fas fa-circle-notch mx-3"
                          :class="isDataLoading ? 'fa-spin' : ''"
                        ></i>
                        {{ !isDataLoading ? "Search" : "" }}</b-button
                      >
                      <b-button variant="outline-primary" @click="clearFields()"
                        >clear</b-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
    <div class="card">
      <div class="p-3">
        <div
          class="d-flex align-items-center justify-content-end"
          @click="reloadQuery"
        >
          <div class="mb-3">
            <i
              v-b-popover.hover="'Refresh All Results'"
              v-if="table.tableData.length != 0"
              class="fas fa-redo-alt"
              :class="isDataLoading ? 'fa-spin' : ''"
            ></i>
          </div>
        </div>
        <div
          class="text-center"
          v-if="table.tableData.length == 0 && !resultsNotFound"
        >
          <h5 class="text-bold mx-5 mb-3">
            Please try a search term or explore website for other relevant
            information.
          </h5>
        </div>
        <div
          class="text-center"
          v-else-if="table.tableData.length == 0 && resultsNotFound"
        >
          <h5 class="text-bold mx-5">
            Hmm.., we couldn't find any results that match your search.<br />
            Please try a different search term or explore website for other
            relevant information.
          </h5>
          <img src="@/assets/images/empty.svg" class="img-fluid mb-3" alt="" />
        </div>
        <div v-else class="table-responsive">
          <div class="table-responsive mb-0" v-dragscroll>
            <v-table
              class="table table-hover mb-0"
              ref="my-table"
              infinite-scroll-disabled="busy"
              infinite-scroll-distance="10"
              :data="table.tableData"
            >
              <thead class="table-light" slot="head">
                <tr>
                  <v-th sortKey="primary_guest.last_name">Guest</v-th>
                  <v-th sortKey="reference_no">Conf No</v-th>
                  <v-th sortKey="booking_source.name">Source</v-th>
                  <v-th sortKey="room_type.name">Room Type</v-th>
                  <v-th sortKey="allotted_room.room_number">Room No</v-th>
                  <th class="text-center">Date</th>
                  <v-th sortKey="reservation_charge">Amount</v-th>
                  <v-th sortKey="current_balance">Balance</v-th>
                  <v-th sortKey="ago">Ago</v-th>
                  <th>Status</th>
                  <th class="booking-table">Action</th>
                </tr>
              </thead>
              <tbody
                class="infinite-list"
                slot="body"
                slot-scope="{ displayData }"
                v-if="!isDataLoading"
              >
                <tr v-for="(data, index) in displayData" :key="index">
                  <td @click="openBookingDetails(data)">
                    <div class="d-flex align-items-center">
                      <div class="position-relative">
                        <img
                          v-if="data.primary_guest.selfie_image != null"
                          class="rounded-circle picture-img"
                          :src="data.primary_guest.selfie_image"
                          alt="Avatar"
                        />
                        <ul
                          v-if="data.primary_guest.selfie_image != null"
                          :class="data.is_read ? 'd-none' : 'neon-dot p-0'"
                        >
                          <li></li>
                        </ul>
                      </div>
                      <span
                        v-if="data.primary_guest.selfie_image != null"
                        class="ms-1"
                        >{{ data.primary_guest.last_name + " " }}
                        {{ data.primary_guest.first_name }}</span
                      >
                      <div
                        v-if="data.primary_guest.selfie_image == null"
                        class="d-flex align-items-center"
                      >
                        <div class="position-relative">
                          <span
                            class="d-flex align-items-center justify-content-center avatar-md-title bg-soft bg-primary text-primary rounded-circle picture-img"
                          >
                            {{
                              avatarGenerator(
                                data.primary_guest.last_name +
                                  " " +
                                  data.primary_guest.first_name
                              )
                            }}
                          </span>
                          <div
                            :class="data.is_read ? 'd-none' : 'neon-dot p-0'"
                          >
                            <li></li>
                          </div>
                        </div>
                        <div class="word-break-text">
                          <span class="ms-2">
                            {{ data.primary_guest.last_name }}
                            {{ data.primary_guest.first_name }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="cursor" v-b-popover.hover.bottom="'click to copy'">
                    <!-- PMS ref -->
                    <div
                      class="overflow-tip"
                      @click="copyCode(data.booking_source_reference_no)"
                      v-if="data.booking_source_reference_no !== null"
                    >
                      <span>PMS {{ data.booking_source_reference_no }}</span>
                    </div>
                    <!-- OTA ref -->
                    <div
                      class="overflow-tip"
                      @click="copyCode(data.ota_reference_no)"
                      v-if="data.ota_reference_no !== null"
                    >
                      <span>OTA {{ data.ota_reference_no }}</span>
                    </div>
                    <!-- Ref -->
                    <div
                      class="overflow-tip"
                      @click="copyCode(data.reference_no)"
                    >
                      <span>Ref {{ data.reference_no }}</span>
                    </div>
                  </td>
                  <td @click="openBookingDetails(data)">
                    {{ data.booking_source.name }}
                  </td>
                  <td @click="openBookingDetails(data)" class="word-break-text">
                    {{ data.room_type !== null ? data.room_type.name : "-" }}
                  </td>
                  <td @click="openBookingDetails(data)">
                    {{
                      data.allotted_room !== null
                        ? data.allotted_room.room_number !== null &&
                          data.allotted_room.room_number !== ""
                          ? data.allotted_room.room_number
                          : "-"
                        : "-"
                    }}
                  </td>
                  <td @click="openBookingDetails(data)">
                    <div
                      class="d-flex align-items-center justify-content-center"
                    >
                      {{
                        global_format_date_and_time_custom(
                          data.check_in_date,
                          "DD MMM"
                        )
                      }}
                      <div class="night-border text-center mx-2">
                        <p
                          class="mb-0 badge-soft-info d-flex align-items-center justify-content-center"
                        >
                          {{ data.stay_night }}
                        </p>
                        <i class="fas fa-long-arrow-alt-right fs-3"></i>
                      </div>
                      {{
                        global_format_date_and_time_custom(
                          data.check_out_date,
                          "DD MMM"
                        )
                      }}
                    </div>
                  </td>
                  <td @click="openBookingDetails(data)">
                    {{ data.reservation_charge }}
                  </td>
                  <td @click="openBookingDetails(data)">
                    {{ data.current_balance }}
                  </td>
                  <td @click="openBookingDetails(data)">
                    {{ getAgo(data.updated_at) }}
                  </td>
                  <td @click="openBookingDetails(data)">
                    <span
                      class="badge align-items-center py-1 px-2 card-badge"
                      :class="[
                        data.status === 'new_booking' ||
                        data.status === 'pre_checkin' ||
                        data.status === 'reservation' ||
                        data.status === 'pre_checked_done'
                          ? 'badge-soft-info'
                          : data.status === 'checked_in'
                          ? 'badge-soft-success'
                          : data.status === 'cancelled' ||
                            data.status === 'no_show'
                          ? 'badge-soft-danger'
                          : data.status === 'checked_out'
                          ? 'badge-soft-warning'
                          : 'badge-soft-secondary',
                      ]"
                    >
                      {{
                        data.status === "new_booking" ||
                        data.status == "pre_checkin"
                          ? "New Booking"
                          : data.status === "reservation"
                          ? "Reservation"
                          : data.status === "pre_checked_done"
                          ? "Pre Checked-In"
                          : data.status === "checked_in"
                          ? "Checked In"
                          : data.status === "checked_out"
                          ? "Checked Out"
                          : data.status === "cancelled"
                          ? "Cancelled"
                          : "No Show"
                      }}
                    </span>
                  </td>
                  <td>
                    <span class="me-3">
                      <i
                        class="fas fa-external-link-alt"
                        v-b-popover.hover="'Open PMS link'"
                        :style="
                          data.pms_url != null
                            ? 'color:#34c38f'
                            : 'color:#bbbfc4'
                        "
                      >
                      </i>
                    </span>
                    <span class="me-3">
                      <i
                        class="fas fa-file-contract"
                        v-b-popover.hover="'Guest Registration'"
                        :style="
                          data.contract_signature !== null
                            ? 'color:#34c38f'
                            : 'color:#bbbfc4'
                        "
                      >
                      </i>
                    </span>
                    <span class="me-3" @click="openBookingDetails(data)">
                      <i
                        class="far fa-credit-card"
                        v-b-popover.hover="'Payment'"
                        :style="
                          data.default_credit_card !== null
                            ? 'color:#34c38f'
                            : 'color:#bbbfc4'
                        "
                      ></i>
                    </span>
                    <span class="me-3" @click="openBookingDetails(data)">
                      <i
                        class="far fa-money-bill-alt"
                        v-b-popover.hover="'Deposit'"
                        :style="
                          data.is_security_deposit_done
                            ? 'color:#34c38f'
                            : 'color:#bbbfc4'
                        "
                      ></i>
                    </span>
                    <span class="me-3" @click="openBookingDetails(data)">
                      <i
                        class="fas fa-sort-amount-up-alt"
                        v-b-popover.hover="'UpSell'"
                        :style="
                          data.upsell_order.length !== 0
                            ? 'color:#34c38f'
                            : 'color:#bbbfc4'
                        "
                      ></i>
                    </span>
                    <span class="me-3" @click="openBookingDetails(data)">
                      <i
                        class="fas fa-address-card"
                        v-b-popover.hover="'Identity'"
                        :style="
                          data.primary_guest !== null &&
                          data.primary_guest.doc_image_status === 'V' &&
                          data.primary_guest.selfie_image_status === 'V'
                            ? 'color:#34c38f'
                            : 'color:#bbbfc4'
                        "
                      ></i>
                    </span>
                    <span
                      v-if="
                        hotel.is_mobile_key_support &&
                        hotel.is_iot_master_connection
                      "
                      :style="
                        data.allotted_room ? 'color:#34c38f' : 'color:#bbbfc4'
                      "
                      class="me-3"
                    >
                      <i
                        class="fas fa-key"
                        v-b-popover.hover="'View Key List'"
                      ></i>
                    </span>
                    <span class="me-3">
                      <i
                        class="fas fa-link"
                        v-b-popover.hover="'Share Link'"
                      ></i>
                    </span>
                    <span v-if="hotel.is_bulk_vs_sms_enable" class="me-3">
                      <i
                        class="mdi mdi-android-messages fs-5"
                        v-b-popover.hover="'Message'"
                      >
                      </i>
                    </span>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr v-for="number in 20" :key="number">
                  <td class="placeholder-glow" v-for="no in 11" :key="no">
                    <span class="placeholder w-100 placeholder-lg"></span>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="!isDataLoading && table.tableData.length == 0">
                <tr>
                  <td colspan="14" class="text-center">
                    <img
                      src="@/assets/images/empty.svg"
                      class="img-fluid"
                      alt=""
                    />
                    <p>
                      <span class="text-secondary">No Data Found</span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </v-table>
          </div>
          <Pagination
            v-if="table.previous !== null || table.next !== null"
            :totalPages="table.totalPages"
            :currentPage="table.currentPage"
            @pagechanged="onPageChange"
          />
        </div>
      </div>
    </div>

    <!-- Method is use for open drawer -->
    <Drawer
      @close="openBookingDetails"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="1240"
      class="w-100"
    >
      <div v-if="viewBookingDetails">
        <BookingDetails :currentProps="bookingDetailsProps" />
      </div>
    </Drawer>
  </div>
</template>
<style scoped>
.neon-dot {
  position: absolute;
  top: 0px;
  right: -2px;
}
.neon-dot li {
  list-style: none;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  animation-delay: -1.2s;
  background: #238dfa;
  box-shadow: 0 0 50px #ffff;
  animation: animate 1.6s ease-in-out infinite;
}
</style>
